module.exports = __webpack_public_path__ + "img/anatomy.13c36ba5.svg";